import { HStack } from '@chakra-ui/react'
import { ReactNode } from 'react'

import { HelpCircleIcon } from '../../components/Icons/HelpCircleIcon'
import { Tooltip } from '../../components/Tooltip/Tooltip'
import { createWidget } from '../widget-utils'

export interface TooltipWidgetProps {
  tooltipHolder?: ReactNode
  tooltipContent?: ReactNode
  children?: ReactNode
  isOpen?: boolean
}

export const TooltipWidget = ({
  children,
  tooltipContent,
  isOpen,
  tooltipHolder,
  ...props
}: TooltipWidgetProps) => {
  return (
    <HStack gap="2" {...props}>
      {tooltipHolder}
      <Tooltip placement="top" isOpen={isOpen} label={tooltipContent}>
        <HelpCircleIcon boxSize={4} stroke="InfoText" />
      </Tooltip>
    </HStack>
  )
}

export const TooltipWidgetDefinition = createWidget(TooltipWidget, {
  type: 'Tooltip',
  slots: ['tooltipHolder', 'tooltipContent'],
})
